/**
 * Un componente che rende una label di upload del file personalizzabile.
 *
 * @param {string} forLabel - L'ID dell'elemento di input a cui è associato questo label.
 * @param {string} altDivClass - Un nome di classe opzionale per il contenitore div dell'etichetta. Il valore predefinito  'btn btn-primary'.
 * @param {string} label - Il testo da visualizzare all'interno dell'etichetta.
 *
 */
export function UploadFileLabel(props) {
  return (
    <>
      <label htmlFor={props.forLabel}>
        <div className={props.altDivClass || 'btn btn-primary'}>
          <i className="star-icon-upload star-icon me-2" />
          {props.label}
        </div>
      </label>
    </>
  )
}
